import React, { useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core";
import ReportsList from "./ReportList/ReportsList";
import ReportPreview from "./ReportPreview";
import ReportDescription from "./ReportDescription";
import ControlsBar from "./ControlsBar";
import t from "../../../languages/pl";
import ReportDetailsWithCars from './../ReportsDetailsDialog/ReportDetailsWithCars';
import ReportDetailsWithDrivers from './../ReportsDetailsDialog/ReportDetailsWithDrivers';
import ActionCreator from './../../../store/actions/index';
import ReportKeywords from './ReportKeywords';
import { useWindowSize } from '../../../utils/hooks/useWindowResize';
import { tabsPanelHeight, toolbarHeight } from './../../../config/constants';

const useStyles = () => ({
    container: {
        width: "100%",
        display: "flex"
    },
    list: {
        float: "left",
    },
    content: {
        float: "right",
        width: "100%"
    }
});

const staticElementsSummedHeight = toolbarHeight + tabsPanelHeight + 10*8 + 68;

const ReportSelection = props => {
    const { classes, selectedReport, availableReports, keywordsList, postReport } = props;
    const [open, setOpen] = useState(null);
    const [isSelected, setIsSelected] = useState(false);
    const { height} = useWindowSize();
    const [elementsHeight, setElementsHeight] = useState({});

    useEffect(() => {
        if(selectedReport.typ_id !== 0){
            setIsSelected(true);
        }
    }, [selectedReport]);

    const handleNewCarsSubmit = (data) => {
        postReport(data);
        setOpen(null);
    };

    const handleDriverReportSubmit = data =>{
        postReport(data);
        setOpen(null);
    };

    const handleReportOrder = () => {
        if (!isSelected) {
            props.openSnackbarInfo(t.selectReportBeforeOrderMsg);
        } else {
            selectedReport !== null && setOpen(true);
        }
    };

    const handleTemplateShow = () => {
        if(!isSelected)
            props.openSnackbarInfo(t.selectReportBeforeImportingTemplateMsg);
    };

    const handleReportSelect = (id) => {
        props.selectReport(id);
    };

    const countPreviewDesiredHeight = (windowHeight) => {
        if(!height || !elementsHeight.description || !elementsHeight.keywords)
            return;
        return windowHeight - staticElementsSummedHeight - elementsHeight.description - elementsHeight.keywords;
    }

    return (
        <div className={classes.container}>
            <div className={classes.list}>
                <ReportsList
                    selectedReport={selectedReport}
                    reports={availableReports}
                    keywords={keywordsList}
                    onReportSelect={handleReportSelect}
                    screenHeight={height}
                />
            </div>
            <div className={classes.content}>
                <ReportPreview height={countPreviewDesiredHeight(height)} />
                <ReportDescription
                    title={t.description}
                    content={selectedReport && selectedReport.opis}
                    onHeightChange={(height) => setElementsHeight(prevHeight => ({...prevHeight, description: height}))}
                />
                <ReportKeywords
                    title={t.keywords}
                    content={selectedReport && selectedReport.tagi}
                    onHeightChange={(height) => setElementsHeight(prevHeight => ({...prevHeight, keywords: height}))}
                />
                <ControlsBar
                    onTemplateShow={handleTemplateShow}
                    onReportOrder={handleReportOrder}
                />
            </div>
            {
                open !== null
                &&
                (
                    !selectedReport.samochody
                        ?
                        <ReportDetailsWithDrivers
                            title={selectedReport.nazwa}
                            open={open !== null}
                            onClose={() => setOpen(null)}
                            autoEnable={selectedReport.automatyczny}
                            onSubmit={handleDriverReportSubmit}
                            isNew
                            typeId={selectedReport.typ_id}
                        />
                        :
                        <ReportDetailsWithCars
                            title={selectedReport.nazwa}
                            open={open !== null}
                            onClose={() => setOpen(null)}
                            autoEnable={selectedReport.automatyczny}
                            onSubmit={handleNewCarsSubmit}
                            isNew
                            typeId={selectedReport.typ_id}
                            onFileSubmit={props.postFile}
                        />
                )
            }
        </div>
    );
};


const mapStateToProps = (state) => ({
    selectedReport: state.reportReducer.selectedReport,
    availableReports: state.reportReducer.availableReports,
    keywordsList: state.reportReducer.keywordsList,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


ReportSelection.propTypes = {
    classes: PropTypes.object,
    postReport: PropTypes.func,
    //redux
    selectedReport: PropTypes.object,
    availableReports: PropTypes.array,
    keywordsList: PropTypes.array,
    getReports: PropTypes.func,
    selectReport: PropTypes.func,
    openSnackbarInfo: PropTypes.func,
    postFile: PropTypes.func,
};

export default compose(
    withStyles(useStyles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ReportSelection);